export class MyTasksConfig {
    static TaskGroupEnabled: boolean = true;
    static TaskPoolEnabled: boolean = true;
}